// extracted by mini-css-extract-plugin
export default {"background":"Background_background__nxhRc"};